import { call, put, takeEvery, select, takeLatest } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import services from '../../services';
import * as models from '../../models'; 
import * as actions from './actions';
import * as constants from './constants';
import { ApiResponse } from 'services/api/base';
import { userActions } from 'store/user';
import { AppToastTypes } from 'models/enums'; 
import { USER_ACTIONS } from 'store/enums';
import { parseApiError } from 'utils/helpers';
import _ from 'lodash'; 


export default function* () {
    yield takeEvery(constants.ADD_CONTACT_SIMPLE, addContactSimple);     
    yield takeEvery(constants.ADD_COMPANY_EXAMINER, addCompanyExaminer); 
    yield takeEvery(constants.ADD_REVIEWER, addReviewer); 
    yield takeEvery(constants.CREATE_CONTACT, createContact); 
    yield takeEvery(constants.REQUEST_ADJUSTERS_DD, requestAdjustersDD); 
    yield takeEvery(constants.REQUEST_COMPANY_EXAMINERS, requestCompanyExaminersList); 
    yield takeEvery(constants.REQUEST_COMPANY_EXAMINERS_DD, requestCompanyExaminerDD); 
    yield takeEvery(constants.REQUEST_CONTACT, requestContact); 
    yield takeEvery(constants.REQUEST_CONTACT_AUDITS, requestContactAudits); 
    yield takeEvery(constants.REQUEST_CONTACT_DUPES, requestContactDupes); 
    yield takeEvery(constants.REQUEST_CONTACT_LIST, requestContactList); 
    yield takeEvery(constants.REQUEST_CONTACT_MERGE, requestContactMerge);
    yield takeEvery(constants.REQUEST_CONTACTS_CSV, requestContactsCSV);
    yield takeEvery(constants.REQUEST_CONTACT_SYNC, requestContactSync); 
    yield takeEvery(constants.REQUEST_EXAMINERS_DD, requestExaminersDD); 
    yield takeEvery(constants.REQUEST_EXAMINERS_LIST, requestExaminersList); 
    yield takeEvery(constants.REQUEST_FIELD_DIRECTORS_DD, requestFieldDirectorsDD); 
    yield takeEvery(constants.REQUEST_FIELD_ADJSTERS_LIST, requestFieldAdjustersList); 
    yield takeEvery(constants.REQUEST_FIELD_DIRECTORS_LIST, requestFieldDirectorsList); 
    yield takeEvery(constants.REQUEST_REVIEWERS_LIST, requestReviewersList); 
    yield takeEvery(constants.REQUEST_REVIEWERS_DD, requestReviewersDD); 
    yield takeEvery(constants.UPDATE_CONTACT, updateContact); 
}

export function* addContactSimple(action: ActionType<typeof actions.addContactSimple>): any {
    const userRequest: ApiResponse = yield call(services.api.contact.addContactSimple, action.payload.request); 
    if (userRequest.isSuccess) {
        yield userRequest;        
    }
    else {
        console.log(userRequest);  
    }        
}

export function* addCompanyExaminer(action: ActionType<typeof actions.addCompanyExaminer>): any {
    const userRequest: ApiResponse = yield call(services.api.contact.addContactSimple, action.payload.contact); 
    if (userRequest.isSuccess) {                
        yield put(actions.requestCompanyExaminersList({pageNo: 1, pageSize: 2000}, action.payload.contact.companyName)); 
    }
    else {
        console.log(userRequest);  
    }     
}

export function* addReviewer(action: ActionType<typeof actions.addReviewer>): any {
    const userRequest: ApiResponse = yield call(services.api.contact.addContactSimple, action.payload.contact); 
    if (userRequest.isSuccess) {                
        yield put(actions.requestReviewersList({pageNo: 1, pageSize: 2000})); 
    }
    else {
        console.log(userRequest);  
    }     
}

export function* createContact(action: ActionType<typeof actions.createContact>): any {
    const userRequest: ApiResponse = yield call(services.api.contact.createContact, action.payload.request); 
    if (userRequest.isSuccess) {
        yield put(actions.receiveContact(userRequest.data)); 
        yield put(userActions.setAppToast({message: "Contact Created", type: AppToastTypes.Success})); 
    }
    else {
        console.log(userRequest); 
        const errorMessage = userRequest.data.error.message || userRequest.data;  
        yield put(userActions.setAppToast({message: errorMessage, type: AppToastTypes.Failure})); 
    }      
}

export function* requestCompanyExaminersList(action: ActionType<typeof actions.requestCompanyExaminersList>): any {
    const contactReqeust: models.ContactsRequest = {
        ...models.defaultContactsRequest,
        ...action.payload.paging,
        type: 'Examiner', 
        companyName: action.payload.companyName
    }
    const userRequest = yield call(services.api.contact.getContacts, contactReqeust); 
    if (userRequest.isSuccess) {
        yield put(actions.receiveCompanyExaminersList(userRequest.data)); 
    }
    else {
        console.log(userRequest.data); 
    }
}

export function* requestContact(action: ActionType<typeof actions.requestContact>): any {
    const userRequest = yield call(services.api.admin.getContactByID, action.payload.contactId);     
    if (userRequest.isSuccess) {
        yield put(actions.receiveContact(userRequest.data)); 
    }
}

export function* requestContactList(action: ActionType<typeof actions.requestContactList>): any {
    const userRequest = yield call(services.api.contact.getContacts, action.payload.request);     
    if (userRequest.isSuccess) {
        yield put(actions.receiveContactList(userRequest.data)); 
    }
    else {
        yield put(actions.requestContactListFailure()); 
        var errorMessage = userRequest.data.error.message; 
        yield put(userActions.setAppToast({message: errorMessage, type: AppToastTypes.Failure})); 
    }
}

export function* requestContactMerge(action: ActionType<typeof actions.requestContactMerge>): any {
    yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_MERGING)); 
    const userRequest = yield call(services.api.contact.mergeContacts, action.payload.contactId, action.payload.payload);
    if(userRequest.isSuccess) {
        yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_MERGE_SUCCESS)); 
        yield put(actions.receiveContactMerge(userRequest.data)); 
        yield put(userActions.setAppToast({message: "Contacts Merged", type: AppToastTypes.Success})); 
        yield put(actions.requestContactDupes(action.payload.contactId)); 
    } else {
        yield put(actions.requestContactMergeFailure());
        const errorMessage = parseApiError(userRequest.data);
        yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_MERGE_FAILURE)); 
        yield put(userActions.setAppToast({message: errorMessage, type: AppToastTypes.Failure})); 
    }   
}

export function* requestContactsCSV(action: ActionType<typeof actions.requestContactsCSV>): any {
    const userRequest = yield call(services.api.contact.getContactsCSV, action.payload.request); 
    if (userRequest){        
        yield put(actions.receiveContactsCSV()); 
    }
}

export function* requestContactAudits(action: ActionType<typeof actions.requestContactAuditLogs>): any {    
    const userRequest = yield call(services.api.contact.getContactAudits, action.payload.request); 
    if (userRequest){        
        yield put(actions.receiveContactAuditLogs(userRequest.data)); 
    }
}

export function* requestContactDupes(action: ActionType<typeof actions.requestContactDupes>): any {
    const userRequest = yield call(services.api.contact.getContactDupes, action.payload.contactId); 
    if (userRequest){        
        yield put(actions.receiveContactDupes(userRequest.data)); 
    }
    else {
        yield put(actions.requestContactDupesFailure()); 
        const errorMessage = userRequest.data.error.message || userRequest.data; 
        yield put(userActions.setAppToast({message: errorMessage, type: AppToastTypes.Failure})); 
    }
}

export function* requestContactSync(action: ActionType<typeof actions.requestContactSync>): any {
    yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_SYNCING)); 
    const userRequest = yield call(services.api.contact.syncContact, action.payload.request); 
    if(userRequest.isSuccess) {
        yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_SYNC_SUCCESS)); 
        yield put(actions.receiveContactSync(userRequest.data)); 
        yield put(userActions.setAppToast({message: "Contact Synced", type: AppToastTypes.Success})); 
    } else {
        const errorMessage = userRequest.data.error.message || userRequest.data; 
        yield put(userActions.setLastUserAction(USER_ACTIONS.CONTACT_SYNC_FAILURE)); 
        yield put(userActions.setAppToast({message: errorMessage, type: AppToastTypes.Failure})); 
    }
}

export function* requestExaminersList(action: ActionType<typeof actions.requestExaminersList>): any {
    const contactRequest:models.ContactsRequest = {
        ...models.defaultContactsRequest,
        ...action.payload.request,
        type: 'Examiner', 
    }
    const userRequest = yield call(services.api.contact.getContacts, contactRequest);
    if (userRequest.isSuccess) {        
        yield put(actions.receiveExaminersList(userRequest.data)); 
    }
}

export function* requestFieldAdjustersList(action: ActionType<typeof actions.requestFieldAdjustersList>): any {
    const contactRequest:models.ContactsRequest = {
        ...models.defaultContactsRequest,
        ...action.payload.request,
        type: 'Field Adjuster', 
    }

    const userRequest = yield call(services.api.contact.getContacts, contactRequest);
    if (userRequest.isSuccess) {        
        yield put(actions.receiveFieldAdjsutersList(userRequest.data)); 
    }
}

export function* requestFieldDirectorsList(action: ActionType<typeof actions.requestFieldDirectorsList>): any {
    const contactRequest:models.ContactsRequest = {
        ...models.defaultContactsRequest,
        ...action.payload.request,
        type: 'Field Director', 
    }

    const userRequest = yield call(services.api.contact.getContacts, contactRequest);
    if (userRequest.isSuccess) {        
        yield put(actions.receiveFieldDirectorsList(userRequest.data)); 
    }
}

export function* requestReviewersList(action: ActionType<typeof actions.requestReviewersList>): any {
    const contactRequest:models.ContactsRequest = {
        ...models.defaultContactsRequest,
        ...action.payload.request,
        type: 'Reviewer', 
    }
    const userRequest = yield call(services.api.contact.getContacts, contactRequest);
    if (userRequest.isSuccess) {        
        yield put(actions.receiveReviewersList(userRequest.data)); 
    }
}

export function* updateContact(action: ActionType<typeof actions.updateContact>): any {      
    const { contactId, patch, updatedContact } = action.payload;
    const state = yield select(); 
    const originalContact = state.contacts.contacts.contact;

    try {
        let user = updatedContact.user;

        // --- 1. HANDLE USER CREATION ---
        if (user && user.userId === 0) {
            const createReq = yield call(services.api.security.createUser, {
                email: updatedContact.email,
                contactId: contactId
            });

            if (createReq.isSuccess) {
                user = createReq.data;
            } else {
                throw new Error("User creation failed: " + (createReq.data?.message || "Internal Error"));
            }
        }

        // --- 2. SYNC ROLES (Groups) ---
        if (user && user.userId) {
            const oldRoles = originalContact.user?.roles || [];
            const newRoles = user.roles || [];

            // Find IDs for these group names from your store/dropdowns
            const allGroups = state.security.groups.Auth2GroupResponse.resourceList;

            // Roles to Add
            const toAdd = _.difference(newRoles, oldRoles);
            for (const roleName of toAdd) {
                const group = allGroups.find((g: any) => g.groupName === roleName);
                if (group) {
                    yield call(services.api.security.updateUserGroupMembership, {
                        userId: user.userId,
                        groupId: group.groupId,
                        isInGroup: true
                    });
                }
            }

            // Roles to Remove
            const toRemove = _.difference(oldRoles, newRoles);
            for (const roleName of toRemove) {
                const group = allGroups.find((g: any) => g.groupName === roleName);
                if (group) {
                    yield call(services.api.security.updateUserGroupMembership, {
                        userId: user.userId,
                        groupId: group.groupId,
                        isInGroup: false
                    });
                }
            }

            // --- 3. SYNC PERMISSIONS ---
            const oldPerms = originalContact.user?.permissions || [];
            const newPerms = user.permissions || [];
            const allPerms = state.security.permissions.Auth2PermissionResponse.resourceList;

            // Permissions to Add
            const pToAdd = _.difference(newPerms, oldPerms);
            for (const permName of pToAdd) {
                const perm = allPerms.find((p: any) => p.permissionName === permName);
                if (perm) {
                    yield call(services.api.security.updateUserPermission, {
                        userId: user.userId,
                        permissionId: perm.permissionId,
                        include: true
                    });
                }
            }

            // Permissions to Remove
            const pToRemove = _.difference(oldPerms, newPerms);
            for (const permName of pToRemove) {
                const perm = allPerms.find((p: any) => p.permissionName === permName);
                if (perm) {
                    yield call(services.api.security.updateUserPermission, {
                        userId: user.userId,
                        permissionId: perm.permissionId,
                        include: false
                    });
                }
            }
        }

        // --- 4. SYNC ACTIVE STATUS ---
        if (user && user.userId) {
            const wasActive = originalContact.user?.isActive;
            const isNowActive = user.isActive;

            if (wasActive !== isNowActive) {
                const toggleReq = yield call(services.api.security.toggleUserActiveFlag, user.userId);
                
                if (!toggleReq.isSuccess) {
                    throw new Error("Failed to update User active status.");
                }
            }
        }

        // --- 5. CONTACT PATCH ---
        const filteredPatch = patch.filter((p: any) => !p.path.startsWith('/user'));
        if (filteredPatch.length > 0) {
            yield call(services.api.contact.updateContact, contactId, filteredPatch);
        }

        yield put(actions.requestContact(contactId)); 
        yield put(userActions.setAppToast({ message: 'Contact & Security Updated', type: AppToastTypes.Success })); 

    } catch (error: any) {
        yield put(actions.updateContactFailure());
        yield put(userActions.setAppToast({ message: error.message || "Update Failed", type: AppToastTypes.Failure })); 
    }
}

// dropdowns
export function* requestAdjustersDD(action: ActionType<typeof actions.requestAdjustersDD>): any {
    const userRequest = yield call(services.api.contact.getAdjusters);
    if (userRequest.isSuccess) {
       yield put(actions.receiveAdjustersDD(userRequest.data)); 
   }    
   else console.log(userRequest);
}

export function* requestCompanyExaminerDD(action: ActionType<typeof actions.requestCompanyExaminersDD>): any {
    const userRequest = yield call(services.api.contact.getCompanyExaminers, action.payload.companyName);
    if (userRequest.isSuccess) {
       yield put(actions.receiveCompanyExaminersDD(userRequest.data)); 
   }    
   else console.log(userRequest);    
}

export function* requestExaminersDD(action: ActionType<typeof actions.requestExaminersDD>): any {
    const userRequest = yield call(services.api.contact.getExaminers);
    if (userRequest.isSuccess) {
       yield put(actions.receiveExaminersDD(userRequest.data)); 
   }    
   else console.log(userRequest);
}

export function* requestFieldDirectorsDD(action: ActionType<typeof actions.requestFieldDirectorsDD>): any {
    const userRequest = yield call(services.api.contact.getFieldDirectors);
    if (userRequest.isSuccess) {
       yield put(actions.receiveFieldDirectorsDD(userRequest.data)); 
   }    
   else console.log(userRequest);
}

export function* requestReviewersDD(action: ActionType<typeof actions.requestReviewersDD>): any {
    const userRequest = yield call(services.api.contact.getReviewers);
    if (userRequest.isSuccess) {
       yield put(actions.receiveReviewersDD(userRequest.data)); 
   }    
   else console.log(userRequest);
}

// Search
export function* requestContactsList(action: ActionType<typeof actions.requestContactsList>): any {
    const userRequest = yield call(services.api.contact.getContacts, action.payload.request);
    if (userRequest.isSuccess) {
       yield put(actions.receiveContactsList(userRequest.data)); 
    }
    else console.log(userRequest);
}